import { useScrollReveal } from "@/hooks/useScrollReveal";
import SiteFooter from "./SiteFooter";

const ThesisLine = ({ text, delay }: { text: string; delay: number }) => {
  const { ref, isVisible } = useScrollReveal(0.3);

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      className={`py-12 md:py-16 transition-all duration-1000 ease-out ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      <p className="text-title md:text-display text-center font-serif max-w-3xl mx-auto leading-relaxed">
        {text}
      </p>
    </div>
  );
};

const TitleBlock = () => {
  const thesisLines = [
    "We study how memory moves.",
    "We design for the undocumented and the unrecorded.",
    "We build infrastructure that complements human nature, not extract it.",
  ];

  return (
    <div className="w-full h-full overflow-y-auto">
      {/* Hero */}
      <section className="min-h-[calc(100vh-3.5rem)] flex flex-col justify-center items-center px-6 md:px-10 relative">
        <div className="text-center max-w-5xl relative z-10">
          {/* Spiral SVG */}
          <div className="mb-12 flex justify-center">
            <svg
              viewBox="0 0 300 300"
              className="w-44 h-44 md:w-56 md:h-56 animate-spin-slow"
            >
              <defs>
                <path
                  id="spiralPath"
                  d="M 150,150 m -130,0 a 130,130 0 1,1 260,0 a 130,130 0 1,1 -260,0"
                  fill="none"
                />
              </defs>
              <text
                className="fill-foreground/70"
                style={{ fontSize: "13px", letterSpacing: "0.22em", fontFamily: "'Cormorant Garamond', serif", textTransform: "uppercase" }}
              >
                <textPath href="#spiralPath">
                  FORGIVENESS · FORGIVENESS · FORGIVENESS · FORGIVENESS · FORGIVENESS · FORGIVENESS ·{" "}
                </textPath>
              </text>
            </svg>
          </div>

          <h1 className="text-hero font-serif uppercase mb-6 opacity-0 animate-[fadeIn_2s_ease-out_0.2s_forwards] tracking-tight">
            Forgiveness Labs
          </h1>
          <p className="text-body-lg text-subtle max-w-2xl mx-auto opacity-0 animate-[fadeIn_2s_ease-out_0.6s_forwards]">
            An applied research studio building ethical systems.
          </p>
        </div>
      </section>

      {/* Thesis lines */}
      <section className="px-6 md:px-10 pb-24">
        <div className="max-w-4xl mx-auto">
          {thesisLines.map((line, index) => (
            <div key={index}>
              {index > 0 && (
                <hr className="border-t border-rule mx-auto max-w-xs" />
              )}
              <ThesisLine text={line} delay={index * 150} />
            </div>
          ))}
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default TitleBlock;
